import { useEffect, useState } from 'react';
import './CookieConsent.css';

const CONSENT_KEY = 'cookie_consent';

interface CookieConsentProps {
  setCurrentPage?: (page: any) => void;
}

export default function CookieConsent({ setCurrentPage }: CookieConsentProps) {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      // Show banner after a short delay
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  function handleAccept() {
    localStorage.setItem(
      CONSENT_KEY,
      JSON.stringify({
        accepted: true,
        timestamp: new Date().toISOString(),
        essential: true,
        functional: true,
        analytics: true,
      })
    );
    setShowBanner(false);
  }

  function handleEssentialOnly() {
    localStorage.setItem(
      CONSENT_KEY,
      JSON.stringify({
        accepted: true,
        timestamp: new Date().toISOString(),
        essential: true,
        functional: false,
        analytics: false,
      })
    );
    setShowBanner(false);
  }

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h2>🍪 Cookie & POPI Act Consent</h2>
          <p>
            We use cookies to enhance your experience and comply with the Protection of Personal
            Information Act (POPIA). By clicking &quot;Accept All&quot;, you consent to our use of
            cookies and the processing of your personal information as described in our{' '}
            <button
              onClick={(e) => {
                e.preventDefault();
                setCurrentPage?.('popi-policy');
              }}
              style={{
                color: '#0066cc',
                textDecoration: 'underline',
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                font: 'inherit',
              }}
            >
              POPI Policy
            </button>
            .
          </p>
          <p style={{ fontSize: '0.9em', marginTop: '0.5rem' }}>
            Essential cookies are required for the website to function. Optional cookies help us
            improve your experience.
          </p>
        </div>
        <div className="cookie-consent-buttons">
          <button onClick={handleAccept} className="btn-accept">
            Accept All
          </button>
          <button onClick={handleEssentialOnly} className="btn-essential">
            Essential Only
          </button>
        </div>
      </div>
    </div>
  );
}
